import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { UserGroups, UserGroupsDetails } from '../../common/models'
import {
  PermissionCategory,
  UserGroupsDetailsPayload,
} from '../../common/models/settings'

export const getUserGroup = (id: string) =>
  http.get<UserGroupsDetails>(`/operations/user-groups/${id}`)

export const updateUserGroup = (id: string, data: UserGroupsDetailsPayload) =>
  http.put<UserGroupsDetails>(`/operations/user-groups/${id}`, data)

export const deleteUserGroup = (id: string) =>
  http.delete(`/operations/user-groups/${id}`)

export const getAllUserGroups = (params?: PaginationParams) =>
  http.get<Pagination<UserGroups>>('/operations/user-groups', {
    params,
  })

export const createUserGroup = (data: UserGroupsDetails) =>
  http.post<UserGroupsDetails>('/operations/user-groups', data)

export const getPermissionsPreset = () =>
  http.get<PermissionCategory[]>('/operations/user-groups/permissions-preset')
